import "./no-orders-page.scss";

export const NoOrdersPage = () => {
	return (
		<div className="no-orders-page-wrapper">
			<img src="/images/stars.gif" className="stars-img" />
			<img src="/images/no-orders-img.webp" className="no-orders-page-img" />
			<div className="no-orders-page-content">
				<img className="no-orders-plane-img" src={"/images/plane.gif"} />
				<div className="no-orders-page-text">
					Stay in touch, <br />
					We will inform you when a new order comes in.
				</div>
			</div>
		</div>
	);
};
